module.exports = __webpack_public_path__ + "media/images/sites/health/luiza-ebea90a16aa76c271ad1a85cf9657beb.jpg";